import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Init from '../../../../Init/Init';
import './Header.scss';

import PrimaryButton from '../../../Utilities/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../../Utilities/SecondaryButton/SecondaryButton';
import PhotoCarousel from '../../ProductPage/PhotoCarousel/PhotoCarousel';
import HeaderValues from './HeaderValues';

// import useAnalyticsEventTracker from '../../../../GoogleAnalytics/useAnalyticsEventTracker';

// const GaTracker = ({
//     action,
//     label
// }) => {
//     const gaEventCategory = 'Header';

//     const gaEventTracker = useAnalyticsEventTracker(gaEventCategory);

//     gaEventTracker(action, label);
// };

const Header = (props) => {
    const {
        firstImage,
        secondImage,
        thirdImage,
        fourthImage,
        fifthImage,
        sixthImage,
        seventhImage
    } = Init.config.header;

    const navigate = useNavigate();

    // Call API
    useEffect(() => {

    }, []);

    const order = (elementId) => {
        const el = document.getElementById(elementId);
        if (el) {
            window.scrollTo({
                top: el.offsetTop,
                behavior: 'smooth'
            });
        }
    }

    const handleAboutUs = () => {
        navigate('/about-us');
    };

    return (
        <div id="header" className="header">
            {/* 
                1. Caps
                2. Image
            */}
            <div className="header-caption">
                <h1 className='header-caption-title'>
                    CUSTOM KEMASANMU #PASTIJADIKEREN DI YOBOY CUP!
                </h1>
                <p className="header-caption-text">
                    PT. Yoboy Oswald Imaji (YOBOY CUP) merupakan perusahaan custom kemasan cup dan box makanan.
                </p>
                <p className="header-caption-text">
                    Kami menjual cup polosan dan menyediakan custom cup plastik, paper cup, paper bowl, dan lain-lain dengan min. 250 pcs aja.
                </p>
                <p className="header-caption-text">
                    Yoboy Cup Indonesia juga tersedia pemesanan via Marketplace yaitu Tokopedia Tiktok, & Shopee khusus untuk pembelian cup & paper box polosan ya. Happy Shopping!
                </p>
                <div className="header-caption-button-container">
                    <PrimaryButton
                        onClick={() => order("ready-stock")}
                        size={'sm'}
                        customClass={"header-caption-button"}
                    >
                        Order Cup Polosan
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={handleAboutUs}
                        size={'sm'}
                        customClass={"header-caption-button"}
                    >
                        Tentang Yoboy Cup
                    </SecondaryButton>
                </div>
                <HeaderValues />
                <div className="header-caption-desc">
                    {/* Brands */}
                </div>
            </div>
            <PhotoCarousel photos={[
                firstImage,
                secondImage,
                thirdImage,
                fourthImage,
                fifthImage,
                sixthImage,
                seventhImage
            ]} />
        </div>
    );
}

export default Header;